import type { PathParams, PathQuery, PathQueryValue } from './types'

export function resolveFullPath(path: string, params: PathParams, query: PathQuery): string {
  const result: string = path.replace(/:(\w+)/g, (match: string, key: string): string => {
    return (params[key] || match).toString()
  })

  if (Object.keys(query).length <= 0) {
    return result
  }

  return `${result}?${queryToString(query)}`
}

function queryToString(query: PathQuery): string {
  const queryWithoutArrayValues: Record<string, string> = {}

  const queryArrayValues: string[] = []

  Object.keys(query).forEach((key: string): void => {
    const val: PathQueryValue = query[key]

    if (Array.isArray(val)) {
      val.forEach((value: string | number): void => {
        queryArrayValues.push(`${key}[]=${value}`)
      })
    } else if (query[key] !== null) {
      queryWithoutArrayValues[key] = query[key] as string
    }
  })

  const queryStringWithoutArrayValues: string = new URLSearchParams(
    queryWithoutArrayValues,
  ).toString()

  if (queryArrayValues.length > 0) {
    return `${queryStringWithoutArrayValues}&${queryArrayValues.join('&')}`
  }

  return queryStringWithoutArrayValues
}
